import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  SUMSKITS_FILTER_REQUEST,
  SUMSKITS_FILTER_SUCCESS,
  SUMSKITS_FILTER_FAILURE,
  SUMSKITS_FILTER_CLEAR,
  SUMSKITS_FILTER_DELETE,
  SUMSKITS_FILTER_SET,
  SUMSKITS_FILTER_UPDATE,
} from 'app/actions/reports/filters/sumsAndKits';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const sumsAndKits = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SUMSKITS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case SUMSKITS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case SUMSKITS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case SUMSKITS_FILTER_CLEAR: {
      return defaultState;
    }
    case SUMSKITS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case SUMSKITS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case SUMSKITS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default sumsAndKits;
